<!-- The message property MUST be set first because of a bug in angular: https://supportcenter.devexpress.com/ticket/details/t1031695/toast-does-not-display-updated-message-in-angular-9 -->
<dx-toast [message]="message" [visible]="isVisible" [type]="isError ? 'error' : 'success'" [displayTime]="displayTime">
  <dxo-position at="top">
        <dxo-offset [y]="yOffset"></dxo-offset>
    </dxo-position>
</dx-toast>